// Shared user-message size cap — used by both the client (pre-send guard,
// so an overlong message never round-trips just to be rejected) and the
// gateway (the authoritative check on the WS 'message' handler). Keep these
// in sync: a client-side-only cap is a UX nicety, not a security boundary —
// the gateway's own check is what actually protects the subprocess stdin
// write (RELEASE-PLAN-DEC24.md §0.3c).
//
// No documented hard limit exists in this codebase for what the Claude Code
// CLI or `codex exec` actually tolerate on stdin — this is a conservative
// constant chosen to stay well clear of any such limit while remaining
// generous for ordinary chat turns (a pasted chapter easily exceeds it,
// which is exactly the "attach as file" case this cap exists to catch).
export const MAX_USER_MESSAGE_CHARS = 32_000;

export function exceedsMaxMessageLength(text: string): boolean {
  return text.length > MAX_USER_MESSAGE_CHARS;
}
